export const LOGO_FIT_SIZE = {
  sm: '/m/fit-in/136x56/filters:fill(FFF)',
  md: '/m/fit-in/232x52/filters:fill(FFF)',
};

export const HIGH_QUALITY_FILTER = 'filters:quality(100)';
export const SB_FORMAT_PARAM = '/m/';
